import React, { ReactNode } from "react";
import styles from "../TherapistSteps.module.scss";

export const TherapistStepsContainer = ({ children }: { children: ReactNode | string }) => (
  <div className={styles.container}>{children}</div>
)